import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) => props.theme.body};
    color: ${(props) => props.theme.text};
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.primary} ${(props) => props.theme.background};
  }

  *::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  *::-webkit-scrollbar-track {
    background: ${(props) => props.theme.background};
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.primary};
    border-radius: 999px;
    border: 3px solid ${(props) => props.theme.background};
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.hover};
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }
  table {
    width: 100%;
  }
`;

export const Container = styled.div`
  color: ${props => props.theme.text};
  margin: 0 auto;
  padding: 0 50px;

  @media (max-width: 600px) {
    padding: 0 20px;
  }
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 0;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const NavList = styled.ul`
  list-style: none;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const NavItem = styled.li`
  margin-left: 20px;
  a {
    color: ${props => props.theme.primary};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${props => props.theme.hover};
    }
  }

  @media (max-width: 600px) {
    margin-left: 0;
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.body};
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  &:not(:disabled):hover {
    background-color: ${props => props.theme.hover};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SplitButtonLeft = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 35px;
  padding: 0px 5px;
  margin: 0px;
  margin-right: 1px;
  vertical-align: middle;
`;

export const SplitButtonRight = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 35px;
  padding: 0px 5px;
  margin: 0px;
  margin-left: 1px;
  vertical-align: middle;
`;

// Keeps the split-button pair on one line and prevents shrinking
export const SplitButtonGroup = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 0;
  flex-shrink: 0;
`;

export const Title = styled.h3`
  color: ${props => props.theme.text};
  /* Reduce extra vertical height in the fixed header */
  margin: 0 10px 6px 10px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.borderColor};
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};

  &::placeholder {
    color: ${props => props.theme.secondary};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.toggleBorder};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.borderColor};
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.toggleBorder};
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: ${props => props.theme.secondary};
  cursor: pointer;
  font-size: 1em;
  line-height: 1;
`;

export const Select = styled.select`
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
  border: 1px solid ${props => props.theme.borderColor};
  border-radius: 4px;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 20px;
  margin-right: 10px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  position: relative;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.toggleBorder};
  }
`;

export const SelectWrapper = styled.div`
  position: relative;

  &::after {
    content: '⌵';
    color: ${props => props.theme.primary};
    right: 15px;
    top: calc(50% - 0.5em);
    position: absolute;
    pointer-events: none;
  }
`;

export const Option = styled.option`
  background: ${props => props.theme.body};
  color: ${props => props.theme.text};

  &:hover,
  &:focus {
    background: ${props => props.theme.background};
  }
`;

export const OptionGroup = styled.optgroup`
  background: ${props => props.theme.body};
  color: ${props => props.theme.text};
`;

export const Card = styled.div`
  color: ${props => props.theme.text};
  background-color: ${props => props.theme.card};
  border-radius: 10px;
  width: 100%;
  height: 100%;
  padding: 20px;
  margin: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`;

export const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  /* Allow dropdowns within cards to render outside the card bounds */
  overflow: visible;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const StyledListItem = styled.li`
  padding: 8px 10px 8px 0;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  &:nth-child(even) {
    background-color: ${props => props.theme.header};
  }
  & ${Select} {
    margin-bottom: 0;
    width: 100%;
  }
  /* Ensure the action area (typically the split button) never wraps */
  & > span:last-child {
    display: inline-flex;
    white-space: nowrap;
    gap: 0;
    flex-shrink: 0;
  }
`;

export const WidgetListItem = styled.li`
  color: ${props => props.theme.text};
  padding: 8px 10px 8px 0;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  display: grid;
  grid-template-columns: 30px 1fr 120px 120px auto auto;
  gap: 10px;
  align-items: center;
  &:nth-child(even) {
    background-color: ${props => props.theme.header};
  }
  & ${Select} {
    margin-bottom: 0;
    width: 100%;
  }
`;

export const AccountsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 20px;
  max-width: 1920px;
  margin: 0 auto;
`;

export const DashboardGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: 400px;
  gap: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  min-width: 400px;
  border-radius: 5px 5px 0 0;
  overflow: visible;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
`;

export const Thead = styled.thead`
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.header};
  text-align: left;
  font-weight: bold;
`;

export const Tbody = styled.tbody`
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.secondary};
  border-bottom: 1px solid ${props => props.theme.borderColor};
`;

export const Tr = styled.tr`
  &:nth-of-type(even) {
    background-color: ${props => props.theme.header};
  }

  &:last-of-type {
    border-bottom: 2px solid ${props => props.theme.primary};
  }

  &:hover {
    background-color: ${props => props.theme.hover};
    cursor: pointer;
  }
`;

export const TrH = styled(Tr)``;

export const Th = styled.th`
  padding: 12px 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Td = styled.td`
  padding: 12px 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: visible;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 500px;
  padding: 20px;
  overflow-x: auto;
  overflow-y: auto;

  @media (max-width: 600px) {
    height: auto;
  }
`;

export const MainContent = styled.main`
  background-color: ${props => props.theme.body};
  padding: 40px;
  /* Reduce gap under fixed header while keeping safe spacing */
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (max-width: 600px) {
    padding: 20px;
    padding-top: 90px;
  }
`;

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  align-items: center;
  vertical-align: middle;

  &:hover {
    cursor: pointer;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  background-color: ${props => props.theme.card};
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1000;
  right: 0;
  border-radius: 4px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
  /* Hide horizontal scrollbar and prevent sideways overflow */
  overflow-x: hidden;

  display: block;

  a, button {
    padding: 10px 20px;
    display: block;
    color: ${props => props.theme.primary};
    text-decoration: none;
    font-size: 0.6em;
    background: none;
    border: none;
    margin: 0;
    border-radius: 0;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      background-color: ${props => props.theme.header};
    }
  }
`;

export const ProfileImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid ${props => props.theme.primary};

  @media (max-width: 600px) {
    width: 40px;
    height: 40px;
  }
`;

export const HeaderLH = styled.header`
  background-color: ${props => props.theme.header};
  color: ${props => props.theme.primary};
  padding: 10px 20px;
  text-align: center;
  font-size: 1.5rem;
  border-bottom: 3px solid ${props => props.theme.primary};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  @media (max-width: 600px) {
    padding: 10px;
  }
`;

export const DivCenter = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width:100%;
  height: 100%;
  background: ${props => props.theme.modalBackground};
  z-index: 2000;
`;

export const ModalContent = styled.div`
  position: fixed;
  background: ${props => props.theme.card};
  color: ${props => props.theme.text};
  width: 600px;
  max-width: 90vw;
  height: auto;
  max-height: 75vh;
  overflow-y: auto;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 2001;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  color: ${props => props.theme.text};
  margin-bottom: 5px;
`;

export const ToggleWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${props => props.theme.primary};
  }

  &:checked + span:before {
    transform: translateX(20px);
  }
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.borderColor};
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: ${props => props.theme.card};
    transition: 0.4s;
    border-radius: 50%;
  }
`;
